import { object, string } from "yup";
import isValidCnpj from "../../../../../utils/isValidCnpj";

export const socialDataAndChargesSchema = object().shape({
  companyCnpj: string()
    .required("CNPJ é obrigatório")
    .test("is-cnpj", "O valor não corresponde a um CNPJ válido", value =>
      isValidCnpj(value),
    ),
  companyName: string().required("Nome da Empresa é obrigatório"),
  taxRegime: string().required("Regime tributário é obrigatório"),
  mainCnae: object().nullable().required("CNAE preponderante é obrigatório"),
  companyHasAgreements: string()
    .required("Convênios / acordos / ajustes é obrigatório")
    .oneOf(["1", "2"], "Selecione uma opção válida para Convênios"),
  emitBoletoSeparately: string().when("companyHasAgreements", {
    is: "1",
    then: string()
      .required("Emite boleto separadamente é obrigatório")
      .oneOf(["1", "2"], "Selecione uma opção válida para Emissão de boleto"),
    otherwise: string().optional().nullable(),
  }),
  codigoTerceiros: object().when("emitBoletoSeparately", {
    is: "1",
    then: object().nullable().required("Código de terceiros é obrigatório"),
    otherwise: object().optional().nullable(),
  }),
  isEmpresaCidada: string()
    .required("Conveniada 'Empresa cidadã' é obrigatória")
    .oneOf(["1", "2"], "Selecione uma opção válida para Empresa cidadã"),
  hasCollectiveVacation: string()
    .required("Aplica férias coletivas é obrigatório")
    .oneOf(["1", "2"], "Selecione uma opção válida para Férias coletivas"),
  collectiveVacationPeriod: string().when("hasCollectiveVacation", {
    is: "1",
    then: string().required("Informe o período das férias coletivas"),
    otherwise: string().optional().nullable(),
  }),
  collectiveVacationDays: string().when("hasCollectiveVacation", {
    is: "1",
    then: string().required("Quantidade de dias de férias coletivas é obrigatória"),
    otherwise: string().optional().nullable(),
  }),
  collectiveVacationByCostCenter: string().when("hasCollectiveVacation", {
    is: "1",
    then: string()
      .required("Por centro de custo/setor é obrigatório")
      .oneOf(["1", "2", "3"], "Selecione uma opção válida para Centro de custo/setor"),
    otherwise: string().optional().nullable(),
  }),
  collectiveVacationOtherRule: string().when("collectiveVacationByCostCenter", {
    is: "3",
    then: string().required("Descreva a regra de negócio para as férias"),
    otherwise: string().optional().nullable(),
  }),
});
